
import { userType } from "../layouts/NewLayout/navbar/constant/userType";

export default {
  computed: {
    _isIndividual() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      return user?.accounttype == userType.individual
    },
    $_3pl() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      return user?.onboardingtype == userType.thirdParty
    },
    $_isAdmin() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      return user.isRoot
    },
    $_isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
  },
}